// extracted by mini-css-extract-plugin
export default {"root":"IconEmptyChemistry_root__Ecc3R"};